import React from 'react';
import { Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';

const NotFound = () => {
  return (
    <>
      <Container
        maxWidth="md"
        style={{marginBottom: 100,}}
      >
        <Grid container>
          <Grid item md={2}></Grid>
          <Grid item md={8} sm={12} xs={12} style={{marginTop: 200, textAlign: 'center'}}>
            <div style={{ marginBottom: "10%",  marginTop: "10%"}}>
              <Typography color="primary" variant="h2">Page Not Found</Typography>
              <Typography color="textSecondary">Sorry but the page you are looking for may be expired or unavailable.</Typography>
              <img style={{width: '70%'}} src="/404.svg" alt="Mobile illustrations by Storyset"/>
            </div>
          </Grid>
          <Grid item md={2}></Grid>
        </Grid>
      </Container>
    </>
  )
}

export default NotFound;